import Vue from "vue";
import Router from "vue-router";
import constantRouterMap from '@/router/static';
import container from '@/components/common/container';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const packageName = 'prismart';
const router = new Router({
    routes: [{
        path: window.__POWERED_BY_QIANKUN__ ? `/${packageName}` : '/',
        name: window.__POWERED_BY_QIANKUN__ ? `/${packageName}` : '/',
        component: container,
        redirect: { name: 'login' },
        children: [...constantRouterMap]
    }],
});

const createRouter = (baseUrl = packageName) => {
    return new Router({
        scrollBehavior: () => ({
            y: 0
        }),
        routes: [{
            path: window.__POWERED_BY_QIANKUN__ ? `/${baseUrl}` : '/',
            name: window.__POWERED_BY_QIANKUN__ ? `/${baseUrl}` : '/',
            component: container,
            redirect: { name: 'login' },
            children: [...constantRouterMap]
        }]
    });
};

function resetRouter(baseUrl) {
    const newRouter = createRouter(baseUrl);
    router.matcher = newRouter.matcher; // reset router
}

router.onError(err => {
    console.log('err', err);
});

export { resetRouter };
export default router;